import loadable from '@loadable/component'

export default [
  {
    path: '/NewYearUnionGame2026',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGame2026" */ '~/pages/NewYearUnionGame2026'
        )
    ),
  },
  {
    path: '/NewYearUnionGame2026/giftbanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGame2026-giftbanner" */ '~/pages/NewYearUnionGame2026/giftbanner'
        )
    ),
  },
  {
    path: '/NewYearUnionGame2026/cardModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGame2026-cardModal" */ '~/pages/NewYearUnionGame2026/cardModal'
        )
    ),
  },
  {
    path: '/NewYearUnionGame2026/animateModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGame2026-animateModal" */ '~/pages/NewYearUnionGame2026/animateModal'
        )
    ),
  },
  {
    path: '/NewYearUnionGame2026/animateModal2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearUnionGame2026-animateModal2" */ '~/pages/NewYearUnionGame2026/animateModal2'
        )
    ),
  },
]
